import { Provider as MobxProvider } from 'mobx-react';
import React, { PropsWithChildren } from 'react';

import { CacheProvider, EmotionCache } from '@emotion/react';
import { GlobalStyles } from '@mui/material';
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ConfigsProvider } from 'modules/configs';
import type { Config, Stores } from 'server/types';

interface Props {
    cache: EmotionCache;
    theme: Theme;
    config: Config;
    stores: Stores;
    queryClient: QueryClient;
}

const globalStyles = (
    <GlobalStyles
        styles={{
            html: {
                overscrollBehavior: 'none'
            },
            '*': {
                WebkitTapHighlightColor: 'transparent'
            }
        }}
    />
);

const BaseProviders: React.FC<PropsWithChildren<Props>> = ({ children, cache, theme, config, stores, queryClient }) => {
    return (
        <StyledEngineProvider injectFirst>
            <CacheProvider value={cache}>
                <ThemeProvider theme={theme}>
                    {globalStyles}
                    <ConfigsProvider value={config}>
                        <MobxProvider {...stores}>
                            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
                        </MobxProvider>
                    </ConfigsProvider>
                </ThemeProvider>
            </CacheProvider>
        </StyledEngineProvider>
    );
};

export default BaseProviders;
